import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import LinearProgress from "@material-ui/core/LinearProgress";

const styles = () => ({
  root: {
    width: "100%"
  },
  barColorPrimary: {
    backgroundColor: "#00a350"
  }
});

class Loading extends Component {
  render() {
    const { isLoading, children, classes } = this.props;
    return (
      <span>
        {isLoading && (
          <LinearProgress
            classes={{
              barColorPrimary: classes.barColorPrimary
            }}
          />
        )}
        {!isLoading && <span>{children}</span>}
      </span>
    );
  }
}

export default withStyles(styles)(Loading);

Loading.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.object,
  classes: PropTypes.object
};
